import React, { createContext, useState, PropsWithChildren } from 'react';

type SuggestionList = Array<unknown>;

type SuggestionContext = {
  loadSuggestions: (config: any) => void;
  suggestions: SuggestionList;
};

export const SuggestionsContext = createContext<SuggestionContext>({
  loadSuggestions: () => {},
  suggestions: [],
});

type Props = {
  getSuggestions: (config: any) => SuggestionList;
  initialSuggestions?: SuggestionList;
};

const defaultProps = {
  initialSuggestions: [],
};

function SuggestionsContextWrapper({
  children,
  getSuggestions,
  initialSuggestions = defaultProps.initialSuggestions,
}: PropsWithChildren<Props>) {
  const [suggestions, setSuggestions] = useState(initialSuggestions);

  const loadSuggestions = React.useCallback(
    (config: any) => {
      const suggestionsNext = getSuggestions(config);
      setSuggestions(suggestionsNext);
    },
    [getSuggestions]
  );

  return (
    <SuggestionsContext.Provider value={{ loadSuggestions, suggestions }}>
      {React.Children.only(children)}
    </SuggestionsContext.Provider>
  );
}

export default SuggestionsContextWrapper;
